import React, { Component } from 'react';
import Panel from './Panel';

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };

    this.activateTab = this.activateTab.bind(this);
  }

  activateTab(index) {
    this.setState(prev => ({
      activeTab: prev.activeTab === index ? -1 : index,
    }));
  }

  render() {
    return (
      <section className={`menu-${this.props.color} ${this.props.background}`} id="menu">
        <div className="container pb-5">
          <div className="align-items-center pt-5">
            <div className={`txt-bold-40px mb-4 txt-uppercase txt-${this.props.color}`}>Menu</div>
            {this.props.data.length > 0 ? (
              <div className="row">
                <div className="accordion offset-md-1 col-md-10" role="tablist">
                  {this.props.data.map((item, index) => (
                    <Panel
                      key={index}
                      activeTab={this.state.activeTab}
                      index={index}
                      activateTab={this.activateTab.bind(null, index)}
                      color={this.props.color}
                      {...item}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="pt-5 pb-5 txt-white">
                <span className="fas fa-circle-o-notch fa-5x fa-spin" />
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js